import { CompanyHub } from "@/features/companies/CompanyHub";
import {
  useAppShell,
  useRefreshProfileAfterCompanyCreated
} from "@/shell/app-shell-context";

/** `/` — mesma tela de `/empresas`, mas só com as empresas recentes. */
export function HomeRoute() {
  const { profile, token, refreshProfile } = useAppShell();
  const companyCreated = useRefreshProfileAfterCompanyCreated();

  return (
    <CompanyHub
      profile={profile}
      token={token}
      onCompanyCreated={companyCreated}
      onCompanyStateChanged={refreshProfile}
      adminHref="/admin"
      isRecentOnly
    />
  );
}
